export const appPaths = {
  LOGOUT: '/logout',
  LOGIN: '/admission/login',
  FORGOT_PASSWORD: '/admission/forgot'
}